import { useMutation } from "@tanstack/react-query";
import { sendBulkSmsToCustomers } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useSendBulkSmsToCustomers = () => {
  const { showNotification } = useNotification();

  return useMutation({
    mutationFn: sendBulkSmsToCustomers,
    onSuccess: (data) => {
      const { sent, failed } = data?.data || {};
      showNotification("success", `SMS sent to ${sent || 0} customer(s)${failed ? `, ${failed} failed` : ""}`);
    },
    onError: (error) => {
      showNotification("danger", error?.response?.data?.error || "Failed to send bulk SMS");
    },
  });
};
